@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Discount</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Discounts reduce the total cost of a booking. They do not act as payments against a booking but a reduction in sales value.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <app-tabview [style]="{'width':'100%'}" [(activeIndex)]="activeIndex" >
            <app-tabpanel header="Basic Settings">
              <div class="field mb-4 col-12">
                <label for="discountname" class="font-medium">Name of the discount</label>
                <input [(ngModel)]="Discount.name" id="discountname" type="text" [ngStyle]="{'border-color': (discountNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
              </div>
              @if (!discountNameValid) {
                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Discount name.</div>
              }
              <!-- <div class="field mb-4 col-12">
              <label for="discountcategory">Discount Category</label>
              <p-selectbutton id="discountcategory" [style]="{'width': '450px'}" [options]="stateOptions4" [(ngModel)]="Discount.isvoucherdiscount" ></p-selectbutton>
            </div> -->
            <div class="field mb-4 col-12">
              <label for="venueclosingstartdate">Discount type</label>
              <p-selectbutton [style]="{'width': '450px'}" [options]="stateOptions3" [(ngModel)]="Discount.discounttype" ></p-selectbutton>
            </div>
            <!-- What the discount comes off. One row per item, name on the left and Yes/No
            on the right, grouped so it reads as a single setting. -->
            @if (!Discount.isvoucherdiscount) {
              <div class="field mb-4 col-12">
                <label>Apply this discount to</label>
                <div class="border-1 surface-border border-round px-3" style="max-width: 450px;">
                  <div class="flex align-items-center justify-content-between py-2 border-bottom-1 surface-border">
                    <span>Admissions</span>
                    <div style="width: 180px;">
                      <p-selectbutton [options]="stateOptions" [(ngModel)]="Discount.discountAdmissions"></p-selectbutton>
                    </div>
                  </div>
                  <div class="flex align-items-center justify-content-between py-2 border-bottom-1 surface-border">
                    <span>Extras</span>
                    <div style="width: 180px;">
                      <p-selectbutton [options]="stateOptions" [(ngModel)]="Discount.discountExtras"></p-selectbutton>
                    </div>
                  </div>
                  <div class="flex align-items-center justify-content-between py-2 border-bottom-1 surface-border">
                    <span>Booking Fee</span>
                    <div style="width: 180px;">
                      <p-selectbutton [options]="stateOptions" [(ngModel)]="Discount.discountFee"></p-selectbutton>
                    </div>
                  </div>
                  <div class="flex align-items-center justify-content-between py-2">
                    <span>Gift Vouchers</span>
                    <div style="width: 180px;">
                      <p-selectbutton [options]="stateOptions" [(ngModel)]="Discount.discountvouchers"></p-selectbutton>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (Discount.discounttype == 'FIXED') {
              <div class="field mb-4 col-12">
                <label for="autogeneratenumber" class="font-medium">Discount Amount</label>
                <p-inputnumber id="autogeneratenumber" [style]="{'width': '300px'}" mode="currency" currency="{{CurrencySymbol}}" [ngModel]="Discount.discountamount == null ? 0: Discount.discountamount" (ngModelChange)="Discount.discountamount = $event" [showButtons]="true" max="10000" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
            }
            @if (Discount.discounttype == 'PERCENTAGE') {
              <div class="field mb-4 col-12">
                <label for="autogeneratenumber" class="font-medium">Discount Amount</label>
                <p-inputnumber id="autogeneratenumber" [style]="{'width': '300px'}" suffix="%" [ngModel]="Discount.discountamount == null ? 0: Discount.discountamount" (ngModelChange)="Discount.discountamount = $event" [showButtons]="true" max="100" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
            }
            <div class="field mb-4 col-12">
              <label for="autogeneratecodes" class="font-medium">Auto Generate Codes</label>
              <p-selectbutton id="autogeneratecodes" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.autogeneratecodes" ></p-selectbutton>
            </div>
            @if (Discount.autogeneratecodes == true) {
              <div class="field mb-4 col-12">
                <label for="autogeneratenumber" class="font-medium">Number of Auto Generated codes</label>
                <p-inputnumber id="autogeneratenumber" [style]="{'width': '300px'}" [ngModel]="Discount.numberofautogeneratedcodes == null ? 0: Discount.numberofautogeneratedcodes" (ngModelChange)="Discount.numberofautogeneratedcodes = $event" [showButtons]="true" max="100000" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
            }
            @if (Discount.autogeneratecodes == false && Discount.code != '[[INSERT NEW CODE]]') {
              <div>
                <div class="field mb-4 col-12">
                  <label for="codename" class="font-medium">Discount code</label>
                  <input [(ngModel)]="Discount.code" id="codename" type="text" pInputText>
                </div>
                @if (!discountCodeValid) {
                  <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Discount Code.</div>
                }
              </div>
            }
            @if (Discount.autogeneratecodes == false && Discount.code == '[[INSERT NEW CODE]]') {
              <div class="field mb-4 col-12">
                <label for="codename" class="font-medium">Discount code</label>
                <input [(ngModel)]="Discount.code" id="codename" type="text" style="border-color:red;" pInputText>
              </div>
            }
          </app-tabpanel>
          <app-tabpanel header="Advanced Settings">
            <div class="field mb-4 col-12">
              <label for="visibility" class="font-medium">Visibility</label>
              <p-selectbutton id="visibility" [style]="{'width': '450px'}" [options]="stateOptions1" [(ngModel)]="Discount.visibility" ></p-selectbutton>
            </div>
            <div class="field mb-4 col-12" style="max-width: 500px;">
              <label for="discountstartdate">Discount Start Date</label>
              <p-datepicker [selectOtherMonths]="true" id="discountstartdate" [(ngModel)]="startDate" readonlyInput="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" (onSelect)="DoDateValidCheck(); DoDateCheck();" [showIcon]="true"></p-datepicker>
              @if (!discountStartDateValid) {
                <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Start Date.</div>
              }
            </div>
            <div style="clear:both;width:100%"></div>
            <div class="field mb-4 col-12" style="max-width: 500px;">
              <label for="discountenddate">Discount End Date</label>
              <p-datepicker [selectOtherMonths]="true" id="discountenddate" readonlyInput="true" [(ngModel)]="endDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" (onSelect)="DoDateValidCheck(); DoDateCheck();" [showIcon]="true"></p-datepicker>
              @if (!discountEndDateValid) {
                <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Start Date.</div>
              }
            </div>
            @if (!discountDateOrder) {
              <div class="text-danger" Style="margin-left:10px; margin-top: 0px;width:100%;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>The Start Date must be before the End Date.</div>
            }
            <div class="field mb-4 col-12">
              <label for="venueclosingstartdate">Available on all days?</label>
              <p-selectbutton id="valiedDaysMonday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.availablealldays" ></p-selectbutton>
            </div>
            @if (Discount.availablealldays == false) {
              <div>
                <div class="field mb-4 col-12">
                  <label style="font-weight: bold">Valid days:</label>
                </div>
                <div class="field mb-4 col-12">
                  <label for="venueclosingstartdate">Monday</label>
                  <p-selectbutton id="valiedDaysMonday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.monday" ></p-selectbutton>
                </div>
                <div class="field mb-4 col-12">
                  <label for="venueclosingstartdate">Tuesday</label>
                  <p-selectbutton id="valiedDaysTuesday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.tuesday" ></p-selectbutton>
                </div>
                <div class="field mb-4 col-12">
                  <label for="venueclosingstartdate">Wednesday</label>
                  <p-selectbutton id="valiedDaysWednesday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.wednesday" ></p-selectbutton>
                </div>
                <div class="field mb-4 col-12">
                  <label for="venueclosingstartdate">Thursday</label>
                  <p-selectbutton id="valiedDaysThursday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.thursday" ></p-selectbutton>
                </div>
                <div class="field mb-4 col-12">
                  <label for="venueclosingstartdate">Friday</label>
                  <p-selectbutton id="valiedDaysFriday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.friday" ></p-selectbutton>
                </div>
                <div class="field mb-4 col-12">
                  <label for="venueclosingstartdate">Saturday</label>
                  <p-selectbutton id="valiedDaysSaturday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.saturday" ></p-selectbutton>
                </div>
                <div class="field mb-4 col-12">
                  <label for="venueclosingstartdate">Sunday</label>
                  <p-selectbutton id="valiedDaysSunday" [style]="{'width': '350px'}" [options]="stateOptions" [(ngModel)]="Discount.sunday" ></p-selectbutton>
                </div>
              </div>
            }
            <div class="field mb-4 col-12">
              <label for="numberofuses" class="font-medium">Number of uses</label>
              <p-inputnumber id="numberofuses" [style]="{'width': '300px'}" [ngModel]="Discount.numberofuses == null ? 0: Discount.numberofuses" (ngModelChange)="Discount.numberofuses = $event" [showButtons]="true" max="100000" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
            </div>
            @if (!Discount.isvoucherdiscount) {
              <div class="field mb-4 col-12">
                <label>Use with: </label>
                <p-selectbutton id="UseOnAllPackages" [style]="{'width': '400px'}" [options]="stateOptions2" [(ngModel)]="Discount.useonallpackages" ></p-selectbutton>
              </div>
            }
            @if (!Discount.isvoucherdiscount && Discount.useonallpackages==false) {
              <div class="surface-card p-4 shadow-2 border-round" style="width:100%;">
                @if (!packagesValid) {
                  <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select at least one package.</div>
                }
                <div class="grid formgrid p-fluid">
                  @if (!isMobile) {
                    <div class="col-12 md:col-6 drag-column">
                      <label class="font-medium">Available Packages</label>
                      <p-table [value]="ListPackages">
                        <ng-template #header>
                          <tr>
                            <th style="width:90%">Name</th>
                            <th style="width:10%">&nbsp;</th>
                          </tr>
                        </ng-template>
                        <ng-template #body let-package>
                          <tr pDraggable="packages" (onDragStart)="dragStart($event, package)" (onDragEnd)="dragEnd()">
                            <td>{{package.name}}</td>
                            <td>
                              <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToList(package)">
                                <span class="pi pi-angle-right"></span>
                              </button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                      @if (ListPackages == null) {
                        <div style="padding: 15px;">
                          <i>No packages available, add some <a href="packageedit/0">here</a></i>
                        </div>
                      }
                    </div>
                  }
                  <div class="cf-col col-12 md:col-6 drop-column" pDroppable="packages" (onDrop)="drop()">
                    <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
                    @if (isMobile) {
                      <div class="cf-add-row">
                        <p-select [options]="ListPackages" [(ngModel)]="picked['packages']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add a package"
                        [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                        <button pButton pRipple type="button" class="p-button-success"
                          [disabled]="picked['packages'] == null" (click)="addPicked('packages', AddToList)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                        </div>
                      }
                      <label class="font-medium">Selected Packages</label>
                      <p-table [value]="Discount.packages">
                        <ng-template  #header let-columns>
                          <tr>
                            <th style="width:90%">Name</th>
                            <th style="width:10%">&nbsp;</th>
                          </tr>
                        </ng-template>
                        <ng-template #body let-package let-columns="columns" let-index="rowIndex">
                          <tr>
                            <td>{{package.name}}</td>
                            <td>
                              <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="RemoveFromList(package)">
                                <span class="pi pi-angle-left"></span>
                              </button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </div>
              }
            </app-tabpanel>
          </app-tabview>
          <div class="col-12">
            <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
            Save Changes</button>
            &nbsp;
            <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
              <span class="pi pi-times" style="margin-right:8px;"></span>
            Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}